import { startCase } from 'lodash';

const getBreadcrumbPath = (subpath, index, array) => {
  let result = subpath;
  for (let i = index; i > 0; i--) {
    result = array[index - 1] + '/' + result;
  }
  return result;
};

export const getBreadcrumbSchema = (slug) => {
  if (!slug) return null;

  const breadcrumbSchema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: slug
      .split('/')
      .filter((subpath) => subpath.length > 0)
      .map((subpath, index, array) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: startCase(subpath.replace(/-/g, ' ')),
        item: `https://cloudkitchens.com/${getBreadcrumbPath(
          subpath,
          index,
          array
        )}/`,
      })),
  };

  if (breadcrumbSchema?.itemListElement?.length < 1) {
    return null;
  } else {
    return JSON.stringify(breadcrumbSchema, null, 2);
  }
};
